import { trimObject } from '@shared/utils';
import apiInstance from './apiInstance';

const omitEmptyQueryParams = (params) => {
  if (!params || typeof params !== 'object') {
    return {};
  }
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined)
  );
};

const get = (url, params = {}) => {
  const queryParams = { params: omitEmptyQueryParams(params) };
  return apiInstance.get(url, queryParams);
};

const post = (url, data = {}) => {
  data = JSON.stringify(trimObject(data));
  return apiInstance.post(url, data);
};

const postBlob = (url, data = {}) => {
  data = JSON.stringify(trimObject(data));
  return apiInstance.post(url, data, { responseType: 'blob' });
};

const put = (url, data = {}) => {
  data = JSON.stringify(trimObject(data));
  return apiInstance.put(url, data);
};

const patch = (url, data = {}) => {
  data = JSON.stringify(trimObject(data));
  return apiInstance.patch(url, data);
};

const methodDelete = (url) => {
  return apiInstance.delete(url);
};

export default { get, post, put, methodDelete, patch, postBlob };
